import React from 'react'
import {NavLink} from 'react-router-dom'

import Icon from '../icons/Icon'

export interface BreadcrumbsLink {
  name: string;
  href: string;
  current: boolean;
}

export interface BreadcrumbsProps {
  links: BreadcrumbsLink[];
}

const Breadcrumbs = ({links}: BreadcrumbsProps) => {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {links.map(link =>
          <li key={link.name}>
            <div className="flex items-center">
              <NavLink
                to={link.current ? '#' : link.href}
                className="mr-2 text-sm font-semibold font-titillium text-kwota-neutral-500"
              >
                {link.name}
              </NavLink>
              <Icon icon="chevron-right" className="fill-kwota-neutral-500" />
            </div>
          </li>
        )}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
